module.exports = __webpack_public_path__ + "static/company-3cb5ca640caa51041392ed7c6a630f70.svg";